<template>
    <div>
        <el-form :inline="true"  @submit.native.prevent :model="searchForm">
            <el-form-item label="下载人：">
                <el-input v-model="searchForm.agentName"  @keyup.enter.native="getDownloadLinks" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain  @click="getDownloadLinks">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- :download="scope.row.fileName+'.xls'" -->
        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column label="文件名" align="center">
                <template slot-scope="scope">
                    <a v-if="scope.row.status == 2 && scope.row.filePath!=null" :href="'http://1.95.118.126:8888/' + scope.row.filePath"  :download = "formatDownloadName(scope.row.fileName, scope.row.filePath)"  target="_blank" >{{ scope.row.fileName  }}</a>

                    <!-- <a v-if="scope.row.status == 2 && scope.row.filePath!=null" href="javascript:void(0);"  @click = "downloadRes( getImgUrl()+scope.row.filePath, scope.row.fileName)"  target="_self" >{{ scope.row.fileName  }}</a> -->
                    <span v-else>{{ scope.row.fileName  }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="startTime" align="center" label="开始时间"></el-table-column>            
            <el-table-column prop="endTime" align="center" label="结束时间"></el-table-column>
            <el-table-column prop="agentName" align="center" label="下载人"></el-table-column>        
            <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                    <span>{{ showbtnText(scope.row.status) }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
    </div>
</template>
<script>
import {exportExcel} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            }
        }
    },
    methods: {
        showbtnText(status){
            return common.showTxtByState(status, {1: '数据处理中', 2: '数据处理完成', 3: '数据处理失败', 4:'已下载'})
        },
        getDownloadLinks($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            exportExcel(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            }).catch(err=>{
                this.$message.error(err.data.message);
            });
        },

        downloadRes(filePath, fileName){
            let iframe = document.createElement('iframe');
            let a = document.createElement('a');
            a.href = filePath;
            //修改文件名
            a.download = this.formatDownloadName(fileName, filePath);
            iframe.appendChild(a);
            document.body.appendChild(iframe)
            
            // 触发点击
            a.click()
            //移除
            setTimeout(() => document.body.removeChild(iframe), 800)
        },

        formatDownloadName(fileName, filePath){
            let nameArr = filePath.split('.');
            return fileName + this.dateFormat('yyyy-MM-dd', new Date()) + '.'+ nameArr[nameArr.length-1];
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getDownloadLinks();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getDownloadLinks();
        }  
    },
    created () {        
        this.getDownloadLinks();
    }
}
</script>
<style lang="less" scoped>

</style>
